module.exports = __webpack_public_path__ + "img/slider.416e58b1.jpeg";